{
  "possibleTypes": {
    "AuditEventSource": [
      "AccessPoliciesAccessRole",
      "AccessPoliciesAdmin",
      "AccessPoliciesServiceAccount",
      "AccessPolicy",
      "AccessRole",
      "AccessRolesAdmin",
      "AccessRolesServiceAccount",
      "Admin",
      "BlockedNetwork",
      "Blocklist",
      "Customer",
      "Example",
      "GoogleShoppingItem",
      "Order",
      "PriceList",
      "PrimecenterInput",
      "Producible",
      "ServiceAccount",
      "ServiceAccountToken",
      "Setting",
      "ShippingTime",
      "Sign",
      "Transaction",
      "TrustedNetwork"
    ],
    "BundleSourceSubject": [
      "Bundle",
      "Order"
    ],
    "ExampleableRecommendableSubject": [
      "Bundle",
      "Sign"
    ],
    "ExampleableSubject": [
      "Bundle",
      "ExampleInterstitial",
      "Sign"
    ],
    "FrontpageBlockable": [
      "FrontpagesExampleCarousel",
      "FrontpagesHero",
      "FrontpagesImage",
      "FrontpagesLinkCardBlock",
      "FrontpagesLinkCarousel",
      "FrontpagesLinkColumnBlock",
      "FrontpagesQuoteCard",
      "FrontpagesQuoteSection",
      "FrontpagesRegularHero",
      "FrontpagesSlidingCarousel",
      "FrontpagesTextBlock",
      "FrontpagesTextImageBlock",
      "FrontpagesVideo"
    ]
  }
}